module.exports = __webpack_public_path__ + "static/media/0.139f9b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/0.png
// module id = 1249
// module chunks = 0